import React from 'react';
import { ContentCardsProps } from '@/components/content-cards/types';
import Card from '@/components/card/Card';

export const ContentCards: React.FC<ContentCardsProps> = ({ cards }) => {
  return (
    <>
      {cards.length && (
        <div className="content-cards-element single-content w-full">
          <div className="container mx-auto grid grid-cols-12 gap-6 px-4 sm:px-0">
            <div className="col-start-1 col-end-13 flex flex-col gap-6 lg:col-start-3 lg:col-end-11 xl:col-start-4 xl:col-end-10">
              <div className="flex w-full flex-col gap-6 md:flex-row md:gap-14">
                {cards.map((card, index) => (
                  <Card
                    key={`${card.title}-${index}`}
                    {...card}
                    className="w-full md:w-1/2"
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
